import { match, P } from 'ts-pattern';
import type { CMSCardTheme } from '../schemas';

const lightTextColor =
  'text-deep-teal-700 [&_[data-component="CMSAverageActivation"]_.average-activation-text]:text-deep-teal-700! [&_.CMSCardContentWrapper]:text-deep-teal-700 [&_.heading]:!text-deep-teal-700 [&_[data-component="CMSText"]_h2]:!text-deep-teal-700 [&_[data-component="CMSText"]_h3]:!text-deep-teal-700 [&_[data-component="CMSText"]_p]:!text-deep-teal-700 [&_[data-component="CMSCTAButton"]_a]:text-deep-teal-700 [&_.iconButton]:text-deep-teal-700 [&_[data-component="CMSText"]_hr]:text-[#B0D8BA]';
const darkTextColor =
  'text-deep-teal-50 [&_[data-component="CMSAverageActivation"]_.average-activation-text]:text-deep-teal-50! [&_[data-component="CMSAverageActivation"]_.average-activation-chip]:bg-deep-teal-400! [&_[data-component="CMSAverageActivation"]_.average-activation-chip]:text-white! [&_.CMSCardContentWrapper]:text-deep-teal-50 [&_.heading]:!text-white [&_[data-component="CMSText"]_h2]:!text-white [&_[data-component="CMSText"]_h3]:!text-white [&_[data-component="CMSText"]_p]:!text-deep-teal-50 [&_[data-component="CMSCTAButton"]_a]:text-deep-teal-50 [&_.iconButton]:text-deep-teal-50 [&_[data-component="CMSText"]_hr]:text-deep-teal-50';

// new brand updates
const darkTextColorNew =
  'text-white [&_[data-component="CMSAverageActivation"]_.average-activation-text]:text-white! [&_[data-component="CMSAverageActivation"]_.average-activation-chip]:bg-white! [&_[data-component="CMSAverageActivation"]_.average-activation-chip]:text-black! [&_.CMSCardContentWrapper]:text-white [&_.heading]:!text-white [&_[data-component="CMSText"]_h2]:!text-white [&_[data-component="CMSText"]_h3]:!text-white [&_[data-component="CMSText"]_p]:!text-white [&_[data-component="CMSCTAButton"]_a]:text-white [&_.iconButton]:text-white [&_[data-component="CMSText"]_hr]:text-white [&_.icon]:text-white!';
const lightTextColorNew =
  'text-black [&_[data-component="CMSAverageActivation"]_.average-activation-text]:text-black! [&_[data-component="CMSAverageActivation"]_.average-activation-chip]:bg-black! [&_[data-component="CMSAverageActivation"]_.average-activation-chip]:text-white! [&_.CMSCardContentWrapper]:text-black [&_.heading]:!text-black [&_[data-component="CMSText"]_h2]:!text-black [&_[data-component="CMSText"]_h3]:!text-black [&_[data-component="CMSText"]_p]:!text-black [&_[data-component="CMSCTAButton"]_a]:text-black [&_.iconButton]:text-black [&_[data-component="CMSText"]_hr]:text-light-grey-300 [&_.icon]:text-black!';
export const getCardThemeStyles = (theme: CMSCardTheme) => {
  return (
    match(theme)
      // TODO: comment to remove this after the migration(probably 1 week)
      // This will be deprecated
      .with(
        P.union('no-fill', 'transparent'),
        () =>
          'bg-transparent [&::before]:bg-transparent [&_.CMSCardContentWrapper]:p-0 md:[&_.CMSCardContentWrapper]:p-0 lg:[&_.CMSCardContentWrapper]:p-0'
      )
      .with(
        'light-green',
        () => `bg-spearmint-500 [&::before]:bg-spearmint-500 ${lightTextColor}`
      )
      .with(
        'mid-green',
        () => `bg-lime-300 [&::before]:bg-lime-300 ${lightTextColor}`
      )
      .with(
        'dark-green',
        () => `bg-deep-teal-700 [&::before]:bg-teal-700 ${darkTextColor}`
      )

      // will not be depreceted
      .with(
        'grey',
        () => `bg-deep-teal-100 [&::before]:bg-deep-teal-100 ${lightTextColor}`
      )
      .with(
        'light-grey',
        () => `bg-deep-teal-350 [&::before]:bg-deep-teal-350 ${lightTextColor}`
      )

      .with('white', () => `bg-white [&::before]:bg-white ${lightTextColorNew}`)
      .with(
        'deep-teal-50',
        () => `bg-deep-teal-50 [&::before]:bg-deep-teal-50 ${lightTextColor}`
      )
      .with(
        'deep-teal-100',
        () => `bg-deep-teal-100 [&::before]:bg-deep-teal-100 ${lightTextColor}`
      )
      .with(
        'deep-teal-500',
        () => `bg-deep-teal-500 [&::before]:bg-deep-teal-500 ${darkTextColor}`
      )
      .with(
        'deep-teal-700',
        () => `bg-deep-teal-700 [&::before]:bg-deep-teal-700 ${darkTextColor}`
      )
      .with(
        'deep-teal-800',
        () => `bg-deep-teal-800 [&::before]:bg-deep-teal-800 ${darkTextColor}`
      )
      .with(
        'lime-50',
        () => `bg-lime-50 [&::before]:bg-lime-50 ${lightTextColor}`
      )
      .with(
        'lime-100',
        () => `bg-lime-100 [&::before]:bg-lime-100 ${lightTextColor}`
      )
      .with(
        'lime-300',
        () => `bg-lime-300 [&::before]:bg-lime-300 ${lightTextColor}`
      )
      .with(
        'spearmint-100',
        () => `bg-spearmint-100 [&::before]:bg-spearmint-100 ${lightTextColor}`
      )
      .with(
        'green-50',
        () => `bg-green-50 [&::before]:bg-green-50 ${lightTextColor}`
      )
      .with(
        'green-100',
        () => `bg-green-100 [&::before]:bg-green-100 ${lightTextColor}`
      )
      .with(
        'tan-100',
        () => `bg-tan-100 [&::before]:bg-tan-100 ${lightTextColor}`
      )

      // new brand updates
      .with('black', () => `bg-black [&::before]:bg-black ${darkTextColorNew}`)
      .with(
        'light-grey-200',
        () =>
          `bg-light-grey-200 [&::before]:bg-light-grey-200 ${lightTextColorNew}`
      )
      .with(
        'custom-warp-green',
        () =>
          `bg-custom-warp-green [&::before]:bg-custom-warp-green ${lightTextColorNew}`
      )
      .with(
        'warp-green-50',
        () =>
          `bg-warp-green-50 [&::before]:bg-warp-green-50 ${lightTextColorNew}`
      )
      .with(
        'warp-green-100',
        () =>
          `bg-warp-green-100 [&::before]:bg-warp-green-100 ${lightTextColorNew}`
      )
      // TODO: add default value
      .otherwise(() => '')
  );
};
